import { Col, message, Row } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { FaqFormCard, FaqInputDto } from "./components/FaqFormCard";
import { fetchFaqById, updateFaqById } from "../../../lib/api/resources/faq";

export const FaqEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const faqQuery = useQuery({
    queryKey: ["faq", id],
    queryFn: async () => fetchFaqById(id),
  });

  const updateFaqMutation = useMutation({
    mutationFn: (data: FaqInputDto) => updateFaqById(id, data),
    onSuccess: () => {
      navigate("/faqs");
      message.success("Vraag & antwoord succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van het vraag & antwoord",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <FaqFormCard
          initialValues={faqQuery.data}
          loading={faqQuery.isLoading}
          mutation={updateFaqMutation}
          title="Vraag & antwoord bewerken"
          buttonText="Bewerken"
        />
      </Col>
    </Row>
  );
};
